// extracted by mini-css-extract-plugin
export default {"order":"Order_order__SCZBI","search":"Order_search__UNecc"};